import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TextBlockTitleVariant,
  TextBlockAlign,
  TextBlockCheckListItemType,
} from '../../../shared/enums/text-block-type.enums';
import { CaasComponents } from '../../../shared/interfaces/caas/caas.interface';
import { CaasBodytextService } from '../../../services/caas-bodytext.service';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'hdi-text-block',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './text-block.component.html',
  styleUrls: ['./text-block.component.scss'],
  host: { id: crypto.randomUUID().toString() },
})
export class TextBlockComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() caasData?: CaasComponents['value'][number];
  @Input() titleVariant?: TextBlockTitleVariant;
  @Input() titleContent?: string;
  @Input() titleAlign?: TextBlockAlign = TextBlockAlign.CENTER;
  @Input() paragraph?: string | SafeHtml;
  @Input() paragraphAlign?: TextBlockAlign = TextBlockAlign.CENTER;

  public readonly TextBlockTitleVariant = TextBlockTitleVariant;
  public readonly TextBlockAlign = TextBlockAlign;
  public readonly TextBlockCheckListItemType = TextBlockCheckListItemType;

  constructor(
    private cdr: ChangeDetectorRef,
    private caasBodytextService: CaasBodytextService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['caasData'] && this.caasData) {
      this.setCaasContent(this.caasData);
      this.cdr.detectChanges();
    }
  }

  ngAfterViewInit(): void {
    this.caasBodytextService.setRouterLinks();
  }

  ngOnDestroy(): void {
    this.caasBodytextService.removeRouterLinks();
  }

  setCaasContent(caasData: CaasComponents['value'][number]) {
    if (!caasData || !caasData.formData) {
      console.warn('TextBlockComponent: caasData or formData is missing');
      return;
    }

    this.setCaasTitle(caasData);

    const bodytext =
      caasData.formData.st_content?.value ||
      caasData.formData.st_bodytext?.value ||
      '';
    if (!bodytext) {
      console.warn('TextBlockComponent: bodytext is missing');
      return;
    }

    this.paragraph =
      this.caasBodytextService.extractTextEditorContent(bodytext);

    const checkListRegex = /<ul[\s\S]*?<\/ul>/gi;
    if (caasData.formData.st_alignment?.value?.identifier === 'center') {
      this.paragraphAlign = checkListRegex.test(bodytext)
        ? TextBlockAlign.LEFT
        : TextBlockAlign.CENTER;
    } else {
      this.paragraphAlign = TextBlockAlign.LEFT;
    }
  }

  setCaasTitle(caasData: CaasComponents['value'][number]) {
    if (
      !caasData ||
      !caasData.formData ||
      !caasData.formData.st_header?.value
    ) {
      console.warn('TextBlockComponent: st_header is missing');
      this.titleContent = '';
      return;
    }

    this.titleContent = caasData.formData.st_header.value;
    this.titleVariant = TextBlockTitleVariant.H2;

    this.titleAlign =
      caasData.formData.st_alignment?.value?.identifier === 'center'
        ? TextBlockAlign.CENTER
        : TextBlockAlign.LEFT;
  }
}
